import { AxiosResponse } from "axios";
import { axiosClient } from "../axiosClient";

export type OfflineActivationRequest = {
  formatVersion: string;
  requestId: string;
  productId: number;
  machineCode: string;
  generatedAtUtc: string;
  applicationVersion?: string;
};

export type OfflineActivationResponse = {
  formatVersion: string;
  requestId: string;
  productId: number;
  serializedCertificate: string;
  generatedAtUtc: string;
};

export const apiOfflineActivationPost = async (
  request: OfflineActivationRequest
): Promise<AxiosResponse<OfflineActivationResponse>> => {
  return axiosClient.post("/offline-activation", request);
};
